import { useCallback } from "react";

import { getPermissionAccess } from "..";

import {
  IAgoraTokenForVideoCallPermissionEnums,
  IAppointmentPermissionEnums,
  IAvailabilitySettingPermissionEnums,
  IDoctorPermissionEnums,
  IDoctorReviewPermissionEnums,
  IIPDashboardPermissionEnums,
  IMedicalRecordPermissionEnums,
  IModalKeyEnums,
  IOPDReceptionWebPermissionEnums,
  IPatientMemberPermissionEnums,
  IPrescriptionAttributesPermissionEnums,
  IPrescriptionPermissionEnums,
  IPrescriptionTemplatePermissionEnums,
  IRolePermissionAccess,
  IScheduleSlotsPermissionEnums,
  ISupportTicketPermissionEnums,
  IUploadDocumentEnums,
  IUserPermissionEnums,
} from "@/models/permission";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  rolePermission,
  setShowPermissionAlert,
} from "@/store/slices/permission";

type IPermissionEnums =
  | IScheduleSlotsPermissionEnums
  | IUserPermissionEnums
  | IAppointmentPermissionEnums
  | IPatientMemberPermissionEnums
  | IAvailabilitySettingPermissionEnums
  | IMedicalRecordPermissionEnums
  | IPrescriptionPermissionEnums
  | IDoctorPermissionEnums
  | ISupportTicketPermissionEnums
  | IUploadDocumentEnums
  | IPrescriptionTemplatePermissionEnums
  | IOPDReceptionWebPermissionEnums
  | IPrescriptionAttributesPermissionEnums
  | IDoctorReviewPermissionEnums
  | IAgoraTokenForVideoCallPermissionEnums
  | IIPDashboardPermissionEnums;

export const usePermissionRestriction = () => {
  const { permission } = useAppSelector(rolePermission);

  const dispatch = useAppDispatch();

  const permissionRestrictionHandler = useCallback(
    (
      modalKey: IModalKeyEnums,
      permissionEnum: IPermissionEnums,
      showAlert = true
    ) => {
      const permissionAccess = getPermissionAccess(
        modalKey,
        permissionEnum,
        permission
      );
      if (permissionAccess === IRolePermissionAccess.NOT_ACCESSIBLE) {
        if (showAlert) {
          dispatch(setShowPermissionAlert());
        }
        return false;
      }
      return true;
    },
    [permission]
  );
  return permissionRestrictionHandler;
};
